import * as React from 'react';

function Home(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.61 14.871h-3.062v4.813c0 .037 0 .075-.017.112-.018.13-.141.204-.247.204h-3.94c-.036 0-.071 0-.106-.018-.141-.038-.23-.13-.23-.26v-.02-6.132H3.107c-.018 0-.053 0-.07-.018C3 13.533 3 13.496 3 13.459l.018-.056c.017-.019.035-.056.052-.074l8.816-9.236c.035-.037.088-.074.123-.074.035-.019.053-.019.088-.019.07 0 .14.037.21.074l.089.093 8.534 9.162c.017.018.017.055.035.074l.035.037v.056c0 .037-.018.056-.053.074H18.08v.037c-.017.15-.017.15-.017 6.059v.074a.288.288 0 01-.247.26h-3.959a.354.354 0 01-.246-.279v-4.85z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Home;
